<template>
<main class="container-1-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2>{{ doc.filename }}</h2>
    </div>

    <div class="container-body">

        <span>¿Realmente deseas eliminar este documento?</span>
        <br>
        <span>Si lo haces, un registro de este recurso quedará en la base de datos</span>
        <br><br>
        <button class="btn btn-danger" style="margin-right: 1em;" v-on:click="deleteDoc()">Sí</button>
        <button class="btn btn-secondary" v-on:click="onClickDontDelete()">No</button>

        <div v-if="validationMessage" class="validation-summary">
            <div class="validation-summary__message">
                {{ validationMessage }}
            </div>
        </div>

    </div>

</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'

import { restDocument } from '@/components/mixin/restDocument.js'

export default{
    name: 'DocumentsDelete',
    mixins: [restDocument],
    data(){
        return{
            validationMessage: '',
        }
    },
    components:{
        Breadcrumb,
    },
    computed: {
        routesBread: function(){
          return [
              {name:'Documentos', path: '/documentos' },
              {name: this.doc.filename, path: '/documentos/' + this.$route.params.idDoc},
              {name: 'Eliminar documento'}
              ]
        }
    },
    props: [],
    methods:{
        onClickDontDelete: function() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/documentos/' + this.$route.params.idDoc + '/editar-documento')
        },
    },
    created () {
        this.$store.getters.getPermissions.documents ? true : this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getDoc();
    }
}
</script>

<style lang="scss" scoped>
.validation-summary {
	margin-top: 1rem;
	padding: 1rem;
	border: 1px solid #dc3545;
	border-radius: 4px;
	background-color: #fff5f5;
}
.validation-summary__message {
	color: #dc3545;
	font-weight: 600;
}
</style>
